export const common = () => {
  // const header = document.getElementById("js-header");
  // const headerScroll = () => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 1 && window.innerWidth > 768) {
  //       header.classList.add("is-scroll");
  //     } else {
  //       header.classList.remove("is-scroll");
  //     }
  //   });
  // };

  // headerScroll();

  /*** 電話番号発信PC禁止 ***/
  const phone = document.querySelectorAll('[href^="tel:"]');

  if (!navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    for(let i = 0; i < phone.length; i++){
      phone[i].style.pointerEvents = "none";
      phone[i].addEventListener('click',(e)=>{
        e.preventDefault();
      })
    }
  }

  // // 確認ダイアログの設定
  // window.onbeforeunload = function(e) {
  //   return 'このページから移動してもよろしいですか？';
  // };

  // // フォーム送信時に確認ダイアログを無効化
  // document.querySelector('form').addEventListener('submit', function() {
  //   window.onbeforeunload = null;
  // });

  /* // 初期読み込み時のチラツキ防止
  // bodyにdisplay: none;追記
  window.addEventListener('DOMContentLoaded',() => {
    document.body.style.display = 'block';
  }); */
}
